import { getApiUrl } from "./tcApiUrl";
export function getSearchEmbargoesURL() {
  const searchembargoesurl = `${getApiUrl("tc/searchEmbargoes")}`;
  return searchembargoesurl;
}

export const getSearchEmbargoesURLValue = () => {
  return getSearchEmbargoesURL();
};
